import NAVBAR from '../../../../DOM/nav/navbar/NAVBAR.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
// Model Structure
export const navFooterAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const navFooterData = makeDataStruct([
    ['navLeft', []],
    ['navCenter', []],
    ['navRight', []]
]);
// Simplified Model
export function navfooter(name, className, navLeft, navCenter, navRight) {
    return {
        attributes: navFooterAttr(name, className),
        data: navFooterData(navLeft, navCenter, navRight)
    };
}
/** A NAVBAR that acts as a CONTAINER Footer*/
export default class NAVFOOTER extends NAVBAR {
    constructor(node, model) {
        super(node, model);
        this.addClass('nav-footer');
    }
}
